import { apiUrl } from "../../apiClient";

import { endpoint } from "../endpoint";
import { customBaseQuery } from "../customBaseQuery";
const { createApi } = require("@reduxjs/toolkit/query/react");

export const vendor_category_api = createApi({
  reducerPath: "vendor_category",
  baseQuery: customBaseQuery,
  tagTypes: ["Category"],
  endpoints: (builder) => ({
    getAllCategories: builder.query({
      query: ({ page, per_page, search }) =>
        `${endpoint.vendor_category}?page=${page}&per_page=${per_page}&search=${
          search || ""
        } `,
      providesTags: ["Category"],
    }),
    addCategory: builder.mutation({
      query: (data) => ({
        url: endpoint.vendor_category,
        method: "POST",
        body: data,
        headers: {
          // FE-SEC-01: Authorization removed; auth via httpOnly cookie.
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }),
      invalidatesTags: ["Category"],
    }),
    getCategorySAPwise: builder.query({
      query: (id) => `${endpoint.vendor_category}/${id}`,
      providesTags: ["Category"],
    }),
  }),
});

export const {
  useGetAllCategoriesQuery,
  useAddCategoryMutation,
  useLazyGetCategorySAPwiseQuery,
} = vendor_category_api;
